import { Component, Input } from '@angular/core';

export interface Status {
  icon: string;
  step: string;
  status: 'pendente' | 'completo';
  ariaLabelStatus?: string;
}

@Component({
  selector: 'app-list-status',
  templateUrl: './list-status.component.html',
  styleUrls: ['./list-status.component.scss'],
})
export class ListStatusComponent {

  @Input()
  listStatus: Status[];



  setAriaLabel(item: Status): string {
    switch (item.status) {
      case 'pendente':
        return `${item.step} Etapa pendente`;
      case 'completo':
        return `${item.step} Etapa completa`;
    }
  }

  setClassStatus(item: Status): string {
    switch (item.status) {
      case 'pendente':
        return item.status;
      case 'completo':
        return item.status;
    }
  }

}
